import styled from 'react-emotion';
import style from './styles';


export interface ButtonProps {
  children?: React.ReactNode;
  color?: string;
  disabled?: boolean;
  fontColor?: string;
  fullWidth?: boolean;
  inverse?: boolean;
  minimal?: boolean;
  shape?: string;
  size: string;
  transparent?: boolean;
  innerRef?: any;
  theme?: any;
}


const SyntheticButton = styled('div') <ButtonProps>`
  padding-top: 0px;
  padding-bottom: 0px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  backgroundColor: transparent;
  vertical-align: middle;
  ${style.getBaseStyle}
  ${style.getBlockStyle}
  ${style.getCircleButtonStyle}
`;

SyntheticButton.defaultProps = {
  color: 'ctaPrimary',
  fontColor: 'light',
  size: 'medium',
  fullWidth: false,
};

export default SyntheticButton;
